var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 42.998,
    viewBox: "0 0 43 42.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20339",
    "data-name": "Group 20339",
    transform: "translate(-390 -296.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20330",
    "data-name": "Group 20330",
    transform: "translate(209 83)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_202",
    "data-name": "Union 202",
    d: "M16608.3-23204.291a21.353,21.353,0,0,1-6.3-15.207,21.339,21.339,0,0,1,6.3-15.2,21.332,21.332,0,0,1,15.2-6.3,21.326,21.326,0,0,1,15.2,6.3,21.335,21.335,0,0,1,6.3,15.2,21.36,21.36,0,0,1-6.3,15.207,21.345,21.345,0,0,1-15.2,6.293A21.35,21.35,0,0,1,16608.3-23204.291Zm-4.3-15.207a19.523,19.523,0,0,0,19.5,19.5,19.525,19.525,0,0,0,19.5-19.5,19.525,19.525,0,0,0-19.5-19.5A19.523,19.523,0,0,0,16604-23219.5Zm16,6.393v-13.781a1,1,0,0,1,1.635-.775l8.422,6.893a1,1,0,0,1,0,1.547l-8.422,6.889a.986.986,0,0,1-.631.229A1,1,0,0,1,16620-23213.105Z",
    transform: "translate(-16421 23454)",
    fill: "#6b6b6b"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.697bf44f75fdefd1c7b75a768a1055f0.svg";
export { ForwardRef as ReactComponent };